import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { generateArray, getClassicBarStyle, getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function ClassicLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  const barCount = 12;

  return (
    <div ref={ref} className={cn('wg-variant-loading__classic-loader', getSizeClass(size), className)}>
      <div className="wg-variant-loading__classic-inner">
        {generateArray(barCount).map(i => (
          <div
            key={i}
            className={cn('wg-variant-loading__classic-bar', getSizeClass(size))}
            style={getClassicBarStyle(size, i)}
          />
        ))}
      </div>
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const ClassicLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(ClassicLoading);
ClassicLoadingComponent.displayName = 'ClassicLoading';

export default ClassicLoadingComponent;
